import { AppError } from '@/util/custom_errors'

export default {
  /**
   * 分類と商品条件のTapirMkフォーマット
   */
  get() {
    return {
      /**
       * @see store.js
       */
      key: new Date().getTime().toString(),
      /**
       * クラスターモード
       *
       * 単品:item / 分類:category
       */
      clusterMode: 'item',
      /**
       * 企業コード
       */
      company: undefined,
      /**
       * 実績なし商品を除外する
       */
      excludeNonActive: false,
      /**
       * 兄弟商品を分析に含める
       */
      includeSiblings: false,
      /**
       * 単品クラスターモードの際の選択モード
       *
       * 単品:item / 分類:category / 階層ファイル:item-group-file
       */
      selectMode: 'item',
      /**
       * 階層ファイル
       */
      itemGroupFile: undefined,
      /**
       * includeSiblingsがtrueの場合の指定階層
       */
      itemCategoryLevel: undefined,
      /**
       * 分類選択
       */
      category: {
        /**
         * 分類階層
         */
        itemCategoryLevel: undefined,
        /**
         * 選択分類（最下層）一覧
         */
        categories: [],
        /**
         * 入力エラー
         */
        errors: [],
      },
      item: {
        /**
         * 選択分類（最下層）一覧
         */
        categories: [],
        /**
         * 選択商品一覧
         */
        items: [],
        /**
         * 入力エラー
         */
        errors: [],
      },
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する分類のフォーマットに変換する
   */
  async mapToApiPayload(item, itemGroupService) {
    const payload = {
      clusterMode: item.clusterMode,
      company: item.company,
      excludeNonActive: item.excludeNonActive,
      includeSiblings: item.includeSiblings,
      selectMode: item.selectMode,
    }

    if (item.includeSiblings) {
      payload.itemCategoryLevel = item.itemCategoryLevel
    }

    if (item.clusterMode === 'category') {
      // 分類でクラスターを行う際には階層付きの分類しかない
      payload.category = {
        company: item.company,
        itemCategoryLevel: item.category.itemCategoryLevel,
        categories: item.category.categories,
      }
    } else if (item.clusterMode === 'item') {
      // 単品でクラスターを行う際には商品指定か分類指定（常に最下層）がある
      if (item.selectMode === 'item') {
        payload.item = {
          company: item.company,
          items: item.item.items.map(i => i.code),
        }
      } else if (item.selectMode === 'category') {
        payload.item = {
          company: item.company,
          categories: item.item.categories,
        }
      }
    }

    if (item.clusterMode === 'item' && item.selectMode === 'item-group-file') {
      let itemGroup

      try {
        itemGroup = await itemGroupService.upload(
          item.company,
          item.itemGroupFile,
        )
      } catch (error) {
        throw new AppError(
          '階層ファイルのアップロードに失敗しました。階層ファイルには「親名称,商品コード」形式のファイルをアップロードしてください。',
        )
      }

      if (itemGroup.columns.length != 2) {
        // 親名称と商品コードの2列あるはず
        throw new AppError(
          '階層ファイルには「親名称,商品コード」形式のファイルをアップロードしてください。',
        )
      }

      payload.itemGroupId = itemGroup.itemGroupId
    }

    return payload
  },
  /**
   * applyToに対してtermを適用する
   */
  applyPayload(applyTo, item) {
    applyTo.key = new Date().getTime().toString()
    applyTo.clusterMode = item.clusterMode
    applyTo.company = item.company
    applyTo.excludeNonActive = item.excludeNonActive
    applyTo.includeSiblings = item.includeSiblings
    applyTo.selectMode = item.selectMode
    if (item.includeSiblings) {
      applyTo.itemCategoryLevel = item.itemCategoryLevel
    }

    if (item.clusterMode === 'category') {
      applyTo.category.company = item.company
      applyTo.category.itemCategoryLevel = item.category.itemCategoryLevel
      applyTo.category.categories = item.category.categories
    } else if (item.clusterMode === 'item') {
      if (item.selectMode === 'item') {
        applyTo.item.company = item.company
        applyTo.item.items = item.item.items
      } else if (item.selectMode === 'category') {
        applyTo.item.company = item.company
        applyTo.item.categories = item.item.categories
      } else if (item.selectMode === 'item-group-file') {
        // ファイル選択は復元できない
      }
    }
  },
}
